import api from './api';

export const CepService = {
  get: ({cep}) => {
    return api.get("/ficha/cep", { params: {
      cep
    } })
  }
}
